import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import EmailIcon from '@mui/icons-material/Email';
import AssessmentIcon from '@mui/icons-material/Assessment';
import { ActionListItem } from '../Components/GenericTable/GenericTableActions';

export const candidateSourcingActionsList: ActionListItem[] = [
  {
    id: 'delete',
    tooltipLabel: 'Delete Search',
    icon: <DeleteIcon style={{ color: '#A15957' }} />
  }
];

export const candidatePoolsActionsList: ActionListItem[] = [
  {
    id: 'emailAnalytics',
    tooltipLabel: 'Email Analytics',
    icon: <AssessmentIcon />
  },
  {
    id: 'bulk_email',
    tooltipLabel: 'Email',
    icon: <EmailIcon />
  },
  {
    id: 'delete',
    tooltipLabel: 'Delete Pool',
    icon: <DeleteIcon />
  }
];
